export const isInitialing = asyncStateValues => asyncStateValues.reduce((acc, curr) => acc || !curr.initialized && curr.loading, false);
export const isAnyLoading = asyncStateValues => asyncStateValues.reduce((acc, curr) => acc || curr.loading, false);
export const getLoadingStateIndex = asyncStateValues => {
  return asyncStateValues.findIndex(asyncStateValue => asyncStateValue.loading);
};
export const isIndexFailed = (asyncStateValues, idx) => {
  var _asyncStateValues$idx;
  return (_asyncStateValues$idx = asyncStateValues[idx]) === null || _asyncStateValues$idx === void 0 ? void 0 : _asyncStateValues$idx.error;
};